export default "__VITE_ASSET__y4ayk0o3__"